import React, { useState } from 'react';
import { Grid, Box } from '@material-ui/core';
import { isIOS } from 'react-device-detect';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { Captions } from 'components/Typography';
import { ChevronRight, ChevronLeft } from 'react-feather';
import { appStore } from 'utils/globalConst';
import { LANGUAGES } from 'store/LanguageProvider/constants';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

import {
  Container,
  StyledShortBody,
  StyledRedirection,
} from 'components/SmartBanner/styles';
import messages from 'components/SmartBanner/messages';
import { translate } from 'helpers/intl';
import { injectIntl, IntlShape } from 'react-intl';

const SmartBanner = (props: { intl: IntlShape }) => {
  const [isOpen, setIsOpen] = useState(true);
  const closeBanner = () => setIsOpen(false);
  const lang = useSelector(getLocaleSelector);

  const isArabic = lang === LANGUAGES.AR;
  const storeRedirection = isIOS ? appStore.ios : appStore.android;
  const Chevron = isArabic ? ChevronLeft : ChevronRight;
  return (
    <Container isOpen={isOpen}>
      <Grid container alignItems="center">
        <Grid item xs={1}>
          <img
            alt="close-banner"
            onClick={closeBanner}
            data-testid="close-banner"
            src={AssuranceIcon['X']}
          />
        </Grid>
        <Grid item xs>
          <StyledRedirection href={storeRedirection} target="_blank">
            <Grid container alignItems="center">
              <Grid item xs={2}>
                <img
                  height="60px"
                  width="60px"
                  src={get(AssuranceIcon, 'smartBannerIcon')}
                  alt="smart-banner-icon"
                />
              </Grid>
              <Grid item xs={9}>
                <Box pl={2}>
                  <StyledShortBody color="#000000" weight="400">
                    {translate(get(messages, 'title'), props)}
                  </StyledShortBody>
                  <Captions color="#505050" weight="400">
                    {translate(get(messages, 'subTitle'), props)}
                  </Captions>
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Chevron color="#404049" />
              </Grid>
            </Grid>
          </StyledRedirection>
        </Grid>
      </Grid>
    </Container>
  );
};

export default injectIntl(SmartBanner);
